// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"ae068a28","453":"2aaec5b8","581":"dbb98a40"}[chunkId] + ".chunk.js";
};